<template>
  <v-dialog name="asd" v-model="modalComputed" persistent  max-width="780" v-if="filialComputed !== undefined">
    <v-card>
      
      <v-toolbar flat color="accent">
        <v-btn icon @click="modalComputed = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>SMTP - Empresa {{filialComputed.cc_fil}}</v-toolbar-title>
      </v-toolbar>

      <v-card-text class="ma-0 pa-0">
        <v-container>
          <v-row>
            <v-col>

              <v-form  ref="form" v-model="valid" :lazy-validation="lazy" class="mt-2" v-on:submit.prevent>
                
                  <div class="d-flex flex-column">
                    <div class="d-flex flex-row">
                        <v-text-field v-model="smtp.tx_url" label="Host" class="mr-2"></v-text-field>
                        <v-text-field v-model="smtp.cn_por" label="Porta" class="mr-2"></v-text-field>
                    </div>
                    <div class="d-flex flex-row">
                        <v-text-field v-model="smtp.tx_usr" label="Usuario" class="mr-2"></v-text-field>
                        <v-text-field v-model="smtp.tx_sen" label="Senha" class="mr-2" type="password"></v-text-field>
                    </div>
                    <div class="d-flex flex-row">
                      <v-container fluid>
                        <v-row>
                          <v-col cols="12" md="6" sm="6">
                            <v-checkbox v-model="smtp.bl_ssl" label="Usa SSL     "></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6" sm="6">
                            <v-checkbox v-model="smtp.bl_tls" label="Usa TLS"></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-container>
                    </div>
                  </div>
                    <v-btn depressed outlined @click="inserir()" color="primary">SALVAR</v-btn>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {

  name: 'Smtp',

  data() {
    return {

      smtp: {
        id_reg: undefined,
        cc_fil: this.filial.cc_fil,
        tx_url: "",
        cn_por: "",
        tx_usr: "",
        tx_sen: "",
        bl_tls: false,
        tx_rem: "",
        tx_ass: "",
        tx_msg: "",
        bl_ssl: false,
      },

      filialTemp: undefined,
      modalTemp: undefined
    }
  },

  props: {

    filial: {
      required: true
    },

    modal: {
      required: true,
      type: Boolean
    },

  },

  methods: {

    listar() {
      this.itens = []
      if(this.filialComputed !== undefined) {
        this.$store.dispatch('pesquisaSMTP', {size:9999, cc_fil: this.filialComputed.cc_fil}).then(resp => {
           resp.data.content.forEach(el => {
                this.smtp.id_reg = el.id_reg
                this.smtp.cc_fil = el.cc_fil
                this.smtp.tx_url = el.tx_url
                this.smtp.cn_por = el.cn_por
                this.smtp.tx_usr = el.tx_usr
                this.smtp.tx_sen = el.tx_sen
                this.smtp.bl_tls = el.bl_tls
                this.smtp.tx_rem = el.tx_rem
                this.smtp.tx_ass = el.tx_ass
                this.smtp.tx_msg = el.tx_msg
                this.smtp.bl_ssl = el.bl_ssl
           });
         }).catch()
      }
    },

    inserir() {
        this.smtp.cc_fil = this.filialComputed.cc_fil
        this.$store.dispatch('salvarSMTP', this.smtp).then(() => {
        this.listar()
        })
    },
  },

  computed: {
    modalComputed :  {
      get: function() { 
        return this.modalTemp
      },
      set: function(value) {
        this.modalTemp = value
      }
    },
    filialComputed: {
      get: function() { 
        return this.filialTemp
      },
      set: function(value) {
        this.filialTemp = value
      }
    }
  },

  mounted: function() {
    this.listar()
  },

  created: function() {
    this.modalComputed = this.modal
    this.filialComputed = this.filial
    this.$emit('a')
  }

}
</script>